import { createFileRoute } from "@tanstack/react-router";

import { SMERoute } from "../../containers/SMERoute";

export const Route = createFileRoute("/_layout-nosidebar/sme")({
    component: SMEFeedback,
});

function SMEFeedback() {
    return <SMERoute />;
}
